var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var CountryModel;
  return CountryModel = (function(_super) {

    __extends(CountryModel, _super);

    function CountryModel() {
      CountryModel.__super__.constructor.apply(this, arguments);
    }

    CountryModel.prototype.pathRoot = core.getConfig().apiPrefix + 'country.json';

    CountryModel.prototype.defaults = function() {
      return {
        id: null,
        code: null,
        name: null,
        currencyId: null
      };
    };

    return CountryModel;

  })(BaseModel);
});
